/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-unresolved */
import { Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import { selectOrder } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';

interface PaymentObject {
  [key: string]: number;
}

const AmountLeft = () => {
  const { total } = useSelector(selectOrder);
  const { data: profile } = useFetchPosProfileDetails();

  const { values } = useFormikContext<any>();

  const filteredObject = Object.keys(values).reduce<PaymentObject>(
    (obj, key) => {
      if (key !== 'loyalty_points') {
        obj[key] = values[key];
      }
      return obj;
    },
    {},
  );

  const objectValues: number[] = Object.values(filteredObject);

  const totalAmount = objectValues.reduce(
    (curr: number, total: number): number => curr + total,
    0,
  );

  const amountToBePaid = total;

  let amountLeft = amountToBePaid - totalAmount;

  if (amountLeft <= 0) {
    amountLeft = 0;
  }

  return (
    <Typography
      sx={{
        color: (theme) => theme.palette.primary.main,
        fontWeight: '600',
        fontFamily: 'Montserrat',

        '& span': {
          ml: 1,
        },
      }}
    >
      Amount left:
      <span>
        {profile?.currency}
        {amountLeft.toLocaleString('en-US')}
      </span>
    </Typography>
  );
};

export default AmountLeft;
